import app from "@/core/shared/services/Firebase/Firebase";

import type { Auth } from "firebase/auth";
import { getAuth } from "firebase/auth";

const firebaseAuthService: Auth = getAuth(app);

export { firebaseAuthService };
